export default "__VITE_PUBLIC_ASSET__f54b952e__"